import { Sparkles, Briefcase, MapPin, Phone, Globe, Building2 } from "lucide-react";

function Pin({ type }) {
  const isJob = type === "jobad";
  return (
    <span
      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ${
        isJob ? "bg-blue-100 text-blue-700" : "bg-emerald-100 text-emerald-700"
      }`}
    >
      {isJob ? <Briefcase className="h-4 w-4" /> : <Sparkles className="h-4 w-4" />}
    </span>
  );
}

export default function ResultsList({ items, selectedId, onSelect, loading }) {
  if (loading) {
    return (
      <div className="space-y-3 p-4">
        <p className="px-1 text-sm font-medium text-slate-500">
          Hämtar riktiga företag i området… det kan ta en liten stund.
        </p>
        {[...Array(6)].map((_, i) => (
          <div key={i} className="h-20 animate-pulse rounded-xl bg-slate-100" />
        ))}
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 px-6 py-16 text-center">
        <Building2 className="h-10 w-10 text-slate-300" />
        <p className="font-semibold text-slate-700">Inga träffar</p>
        <p className="text-sm text-slate-500">
          Prova att välja fler städer eller ändra filtren.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-2 p-3">
      {items.map((it) => {
        const isJob = it.type === "jobad";
        const active = it.id === selectedId;
        return (
          <button
            key={it.id}
            data-testid={`result-item-${it.id}`}
            onClick={() => onSelect(it)}
            className={`jk-fade-up flex w-full items-start gap-3 rounded-xl border p-3 text-left transition-all ${
              active
                ? "border-emerald-400 bg-emerald-50/60 shadow-sm"
                : "border-slate-200 bg-white hover:border-slate-300 hover:shadow-sm"
            }`}
          >
            <Pin type={it.type} />
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <p className="truncate font-semibold text-slate-900">{it.name}</p>
              </div>
              <p className="truncate text-sm text-slate-500">
                {isJob ? it.headline || it.industry : it.industry}
              </p>
              <div className="mt-1.5 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-400">
                <span className="inline-flex items-center gap-1">
                  <MapPin className="h-3 w-3" /> {it.city}
                </span>
                {!isJob && it.phone && (
                  <span className="inline-flex items-center gap-1">
                    <Phone className="h-3 w-3" /> {it.phone}
                  </span>
                )}
                {!isJob && it.website && (
                  <span className="inline-flex items-center gap-1">
                    <Globe className="h-3 w-3" /> Webb
                  </span>
                )}
              </div>
            </div>
            <span
              className={`mt-0.5 shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${
                isJob ? "bg-blue-100 text-blue-700" : "bg-emerald-100 text-emerald-700"
              }`}
            >
              {isJob ? "Annons" : "Spontant"}
            </span>
          </button>
        );
      })}
    </div>
  );
}
